import { FeaturesEnum } from '~/features/types';
import { PermissionEnum } from '~/roles/types';

export default [
  {
    path: '/notifications',
    meta: {
      auth: true,
      permissions: [PermissionEnum.NOTIFICATIONS],
      feature: FeaturesEnum.NOTIFICATIONS,
    },
    component: () => import('~/common/layouts/default.vue'),
    children: [
      {
        path: '',
        name: 'notifications',
        component: () => import('~/notifications/pages/Index.vue'),
      },
    ],
  },
];
